import FlexContainerView from './FlexContainer.view'

export const FlexContainerLogic = ({ children, style }) => <FlexContainerView children={children} style={style} />
